module.exports = __webpack_public_path__ + "static/ring_of_three_wishes-9b0701da07179c6c169bffad7897367f.jpeg";